import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useViewCalendar } from './useViewCalendar';
import {
  getCalendarRowViewFields,
  getViewPeriodTitle,
} from '../calendarViewSections';
import UIHelper from 'helpers/UIHelper';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const CalendarView = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { singleData, loading, groupBy, date, backendFilters } =
    useViewCalendar();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';
  const canUpdate = singleData.some((row) => row.can_update !== false);

  const pageTitle = isSuccessUpdatePage
    ? t('PAGE WAS SUCCESSFULLY UPDATED')
    : getViewPeriodTitle(date, groupBy, t);

  const editLink = `/admin/calendars/${date}/edit?by_group=${groupBy}`;

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {singleData.map((row) => (
            <ViewSection
              key={row.id}
              title={UIHelper.formatedDate(
                row.calendar_date,
                'DD MMMM YYYY',
              )}
              fields={getCalendarRowViewFields(t, row, backendFilters)}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {canUpdate && (
            <Col>
              <Button>
                <Link to={editLink}>{t('MODIFIICA')}</Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/calendars'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CalendarView;
